<template lang="pug">

  div
    div( class="d-flex justify-content-between align-items-center" )
      MHeader(
        page-title="Submit Links"
        v-bind:breadcrumbs="breadcrumbs"
      )
      div( v-if="$moonpull.currentUserIsSuperAdmin()" style="margin-top:25px;" )
        router-link( class="btn btn-primary" v-bind:to="$moonpull.nuxtUrl('/submission')" )
          MMoonpullIcon( class="mr-2" )
          i( class="fa fa-external-link mr-2" )
          | To Atlas Submission
    
    div( v-if="loading" ) Loading...
    div( v-else class="wrapper wrapper-content" )
      div( class="row d-flex align-items-stretch" )

        div( class="col-lg-3 d-flex flex-grow-1" )
          div( class="ibox d-flex flex-grow-1" )
            div( class="ibox-content w-100" )
              h5 Max Batch Size
              h1( class="no-margins" ) {{ company.maxBatchSize === null ? 'N/A' : company.maxBatchSize }}
              div( class="m-t-sm small" ) The amount of links you can run per batch

        div( class="col-lg-3 d-flex flex-grow-1" )
          div( class="ibox d-flex flex-grow-1" )
            div( class="ibox-content w-100" )
              h5 Monthly Allowance
              h1 {{ company.numMonthlyLinks + company.numExtraMonthlyLinks }}
              div( class="m-t-sm small" )
                p( class="m-0" ) Your Contract: {{ company.numMonthlyLinks }}
                p( class="m-0" v-if="company.numExtraMonthlyLinks" ) Added by Moonpull: {{ company.numExtraMonthlyLinks }}
                p( class="m-0" v-if="company.nextResetDate" ) Limit resets on: {{ dateFormat(company.nextResetDate, 'dS mmmm') }}
        
        div( class="col-lg-3 d-flex flex-grow-1" )
          div( class="ibox d-flex flex-grow-1" )
            div( class="ibox-content w-100" )
              h5 This Month Only
              h1( class="no-margins" ) {{ company.numExtraMonthlyLinks }}
              div( class="m-t-sm small" v-if="company.thisMonthExtra" )
                p( class="m-0" ) Extra links expire on: {{ dateFormat(company.thisMonthExtra.expires, 'dS mmmm') }}
        
        div( class="col-lg-3 d-flex flex-grow-1" )
          div( class="ibox d-flex flex-grow-1" )
            div( class="ibox-content w-100" )
              h5 This Month Remaining
              h1( class="no-margins" v-bind:class="`text-${linksRemainingProgressBarClass}`" ) {{ company.remainingAudits }}
              div( class="progress progress-mini" )
                div(
                  class="progress-bar"
                  v-bind:class="`progress-bar-${linksRemainingProgressBarClass}`"
                  v-bind:style="`width: ${100 - percentageLinksRemaining}%`"
                )
              div( class="m-t-sm small" ) Used: {{ company.numAudits }}

      div( class="tabs-container" )
        ul( class="nav nav-tabs" role="tablist" )
          li
            a( v-bind:class="[ 'nav-link', currentTab === 'single-with-data' && 'active' ]" v-on:click.prevent="changeTab('single-with-data')" ) Single Link

          li
            a( v-bind:class="[ 'nav-link', currentTab === 'upload' && 'active' ]" v-on:click.prevent="changeTab('upload')" ) Batch Upload

          li( v-if="$moonpull.currentUserHasAccessTo('techPublisherSubmission')" )
            a( v-bind:class="[ 'nav-link', currentTab === 'techPublisher' && 'active' ]" v-on:click.prevent="changeTab('techPublisher')" )
              | &nbsp;Tech Publisher
          
          li( v-if="$moonpull.currentUserHasAccessTo('consentSubmission')" )
            a( v-bind:class="[ 'nav-link', currentTab === 'consentAnalysis' && 'active' ]" v-on:click.prevent="changeTab('consentAnalysis')" )
              | &nbsp; Consent Checker
          
          li( v-if="$moonpull.currentUserHasAccessTo('multiSubmission')" )
            a( v-bind:class="[ 'nav-link', currentTab === 'multiCountry' && 'active' ]" v-on:click.prevent="changeTab('multiCountry')" )
              | &nbsp;Multi-Country
                  
        div( class="tab-content" )
          div( v-bind:class="[ 'tab-pane', currentTab === 'single-with-data' && 'active' ]" )
            div( class="panel-body" )
              h2 Single link with details
              MForm( v-on:submit="submitLink" submit-text="Submit Link" )
                MModalButton( button-classes="btn-link font-bold" modal-size="modal-lg" title="Single Link Submission" )
                  span( slot="button-inner" )
                    | Help Panel
                    i( class="fa fa-question inline-block ml-2" )
                  p( slot="body" class="text-left font-normal" )
                    ul
                      p The following fields are compulsory:

                      p Affiliate link, Network choice, Advertiser name, Country Code and Submission name. 

                      p The Submission description is optional.

                      p Tags A to E can be completed to aid your categorisation for analysis.
                      
                      p Cookie name and Cookie Type can be specified to override default network first party cookie parameters, and indeed those in the 'Advertiser Information'.

                      p The cookie type is either 'ANI' which means the cookie includes the Affiliate Network Identifier or 'wildcard' where it does not.  Wildcard might be selected if the advertiser is using a GUID cookie methodology.
                
                MInput(
                  type="text"
                  required
                  name="batchName"
                  label="Advertiser Name"
                )
                MInput(
                  type="text"
                  name="batchDescription"
                  label="Advertiser Description"
                )
                MInput(
                  type="text"
                  required
                  name="link"
                  label="Affiliate Link"
                )
                MInput(
                  type="select"
                  name="userDefinedNetwork"
                  required
                  v-bind:options="networks.map(n => ({ label: n.name, value: n.name }))" 
                  label="Network" 
                  v-on:change="onNetworkChange"
                )

                div( class="alert alert-warning text-center" v-if="showLinkConnectorReferrerWarning" )
                  | The selected network may require the "Referrer" which can be set in "Additional Fields" below

                MInput(
                  type="select"
                  required
                  name="countryCode"
                  v-bind:options="countryCodes"
                  value="gb"
                  label="Country Code"
                )
                  MModalButton( slot="description" container-classes="d-inline" button-classes="btn-link font-bold" modal-size="modal-lg" title="Choosing a Queue" )
                    span( slot="button-inner" )
                      |
                      i( class="fa fa-question inline-block ml-2" )
                    p( slot="body" class="text-left font-normal" )
                      ul
                        p Moonpull asks you to select a Country Code for link submission.

                        p Moonpull utilises data centres in approximately 50 counties, with the data centre specified within the submission data using the relevant ISO Alpha-2 code. 

                        p If you choose a country for which Moonpull is not confgured it will default to the UK (ISO code GB).

                        p For more details on the territories for which Moonpull is configured please contact your Moonpull lead.

                        p Moonpull provides a badge in the Audit Results Details to confirm the data centre that was used.

                div( class="form-group row")
                  div( class="ml-3 d-flex align-items-center" )
                    input( type="checkbox" v-model="batchMeta.notifyOnComplete" )
                  label( class="col-sm-10 col-form-label" ) Send email notification on completion

                div( class="my-2")
                  label
                    input( type="checkbox" v-model="linkView")
                    em( class="ml-2") Additional Fields
                div( v-if="linkView" )
                  hr
                  MInput( 
                    type="text"
                    name="cookieName"
                    label="Cookie Name:"
                  )
                  MInput(
                    type="select" 
                    name="cookieType"
                    v-bind:options="cookieTypeOptions" 
                    label="Cookie Type:"
                  )
                  MInput(
                    type="text"
                    name="customAni"
                    label="Custom ANI:"
                  )
                  MInput(
                    type="text"
                    name="referrer"
                    label="Referrer:"
                  )

                  MInput(
                    v-if="$moonpull.currentUserHasAccessTo('customMasterTagSubmission')"
                    type="text"
                    name="customMasterTag"
                    label="Custom Master Tag:"
                    description="Provided value will be a \"wildcard\" check. e.g. providing \"xyz\" will match successfully on \"https://mysite.com/xyz.js\""
                  )

                  hr

                  MInput(
                    type="text"
                    name="tagA"
                    label="Tag A:"
                  )
                  MInput(
                    type="text"
                    name="tagB"
                    label="Tag B:"
                  )
                  MInput( 
                    type="text"
                    name="tagC"
                    label="Tag C:"
                  )
                  MInput( 
                    type="text"
                    name="tagD"
                    label="Tag D:"
                  )
                  MInput( 
                    type="text"
                    name="tagE"
                    label="Tag E:"
                  )
                  MInput( 
                      type="checkbox" 
                      name="useLite"
                      label="Use Moonpull Lite?"
                      checked
                    )
                  hr
                  template( v-if="$moonpull.currentUserIsSuperAdmin()" )
                    span
                      MMoonpullIcon
                      | &nbsp; SU Only
                    MInput(
                      type="checkbox"
                      name="proxyYN"
                      label="Residential Proxy:"
                    )
                    MInput( 
                      type="select"
                      name="proxyCountryCode"
                      v-bind:options="countryCodes"
                      label="Proxy Region"
                    )
                    MInput( 
                      type="checkbox" 
                      name="extraTimeout"
                      label="Extra Timeout"
                    )

                  MLinkCheckerQueueSelector(
                    v-if="! $apollo.loading"
                    v-bind:company="company"
                    v-bind:batch-meta="batchMeta"
                    v-bind:queue-counts="queueCounts"
                  )

          div( v-bind:class="[ 'tab-pane', currentTab === 'upload' && 'active' ]" )
            div( class="panel-body text-left" )
              h2 Batch Upload
              p You must specify a name and it is recommended you add a description too. You should also specify a Country Code in the submission data. It is recommended that you also supply a merchant name. For details on the permitted Country Code fields see your Moonpull lead.
              div( class="form-group row" )
                label( class="col-sm-2 col-form-label" ) Name
                div( class="col-sm-10" )
                  input( class="form-control" v-bind:class="{ 'is-invalid': ! validBatchName }" type="text" v-model="batchMeta.name" )
                  div( class="invalid-feedback" v-if="! validBatchName" ) Please provide a name for your batch
              
              div( class="form-group row" )
                label( class="col-sm-2 col-form-label" ) Description
                div( class="col-sm-10" )
                  input( class="form-control" type="text" v-model="batchMeta.description" )
              
              h3( class="mt-4" ) Additional Options

              div( class="form-group row" )
                label( class="col-sm-4 col-form-label" ) Send email notification on completion
                div( class="col-sm-8" )
                  input( style="width:20px;" class="form-control" type="checkbox" v-model="batchMeta.notifyOnComplete" )
              
              MLinkCheckerQueueSelector(
                v-bind:company="company"
                v-bind:batch-meta="batchMeta"
                v-bind:queue-counts="queueCounts"
              )

              strong Please upload a CSV in #[a( href="#" v-on:click.prevent="downloadCsv()" ) Moonpull's specific format]

              div( class="custom-file" )
                input( id="csv" class="custom-file-input" type="file" v-on:change="updateCsvFile($event)" )
                label( for="csv" class="custom-file-label" ) {{ csv === null ? 'Choose file...' : csv.name }}

              div( class="ibox mt-4" )
                div( class="ibox-title toggle-moonpull-admin-options" v-on:click="toggleAdditionalOptions" )
                  div( class="row" )
                    div( class="col-6" )
                      strong Additional Submission Options

                    div( class="col-6 text-right")
                      i( class="fa" v-bind:class="(showAdditionalOptions) ? 'fa-chevron-up' : 'fa-chevron-down'" )
                
                div( class="ibox-content" v-bind:class="(showAdditionalOptions) ? 'd-block' : 'd-none'" )
                  
                  div( class="form-group row" v-if="$moonpull.currentUserIsSuperAdmin()" )
                    label( class="col-sm-4 col-form-label" )
                      MMoonpullIcon
                      |  Stand down MR(AS)?
                      br
                      small (Also prevents GR from being applied)
                    div( class="col-sm-8" )
                      input( style="width:20px;" class="form-control" type="checkbox" v-model="batchMeta.standDownMrAs" )
                
                  div( class="form-group row" v-if="$moonpull.currentUserIsSuperAdmin()" )
                    label( class="col-sm-4 col-form-label" )
                      MMoonpullIcon
                      |  Run as mobile user
                    div( class="col-sm-8" )
                      input( style="width:20px;" class="form-control" type="checkbox" v-model="batchMeta.runAsMobile" )
                  
                  div( class="form-group row" v-if="$moonpull.currentUserIsSuperAdmin()" )
                    label( class="col-sm-4 col-form-label" )
                      MMoonpullIcon
                      |  Submit entire batch through Lite w/ media?
                    div( class="col-sm-8" )
                      input( style="width:20px;" class="form-control" type="checkbox" v-model="batchMeta.forceLiteSubmission" )
                  
                  div( class="form-group row" v-if="$moonpull.currentUserHasAccessTo('convertalinkSubmission')" )
                    label( class="col-sm-4 col-form-label" ) Process via convert-a-link? (Provide Publisher ID)
                    div( class="col-sm-8" )
                      input( style="width:20%;" class="form-control" type="text" v-model="batchMeta.convertalinkPublisherId" )

                  div( v-if="$moonpull.currentUserHasAccessTo('setContextLoyalty')" class="form-group row" )
                    label( class="col-sm-4 col-form-label" ) Set Loyalty Submission
                      br
                      small (For CJ)
                    div( class="col-sm-8" )
                      input( style="width:20px;" class="form-control" type="checkbox" v-model="batchMeta.setLoyaltyContext" )

              div( class="mt-3 row" )
                div( class="col-6" )
                  p( style="color:red;" v-if="fileUploadError !== ''" ) {{ fileUploadError }}
                div( class="col-6 text-right" )
                  button( id="uploadBtn" class="btn btn-primary" v-bind:disabled="csv === null || loading" v-on:click="uploadCsv" ) Start Auditing
                  
          div( v-bind:class="[ 'tab-pane', currentTab === 'singleData' && 'active' ]" )
            div()

          div( v-bind:class="[ 'tab-pane', currentTab === 'techPublisher' && 'active' ]" )
            div( class="panel-body text-left" )
              h2 Batch project creation submission - Tech publishers
              p This creates a batch of links in a pre-defined format looking at different tracking scenarios

              MForm( v-on:submit="submitTechLink" v-bind:submit-text="techPublisherSubmitText" )

                MInput(
                  type="select"
                  name="techPublisherScenario"
                  label="Tech Publisher Scenario"
                  value="simplified"
                  v-bind:options="techPublisherScenarios"
                  v-on:change="onTechPublisherScenarioChange"
                  required
                )

                MInput(
                  type="text"
                  required
                  name="batchName"
                  label="Advertiser Name"
                )

                MInput(
                  type="text"
                  name="batchDescription"
                  label="Advertiser Description"
                )

                MInput(
                  type="text"
                  required
                  name="link"
                  label="Affiliate Link"
                )

                MInput(
                  type="select"
                  required
                  name="countryCode"
                  v-bind:options="countryCodes"
                  value="gb"
                  label="Country Code"
                )
                  MModalButton( slot="description" container-classes="d-inline" button-classes="btn-link font-bold" modal-size="modal-lg" title="Choosing a Queue" )
                    span( slot="button-inner" )
                      |
                      i( class="fa fa-question inline-block ml-2" )
                    p( slot="body" class="text-left font-normal" )
                      ul
                        p Moonpull asks you to select a Country Code for link submission.
                        p Moonpull utilises data centres in approximately 50 counties, with the data centre specified within the submission data using the relevant ISO Alpha-2 code. 
                        p If you choose a country for which Moonpull is not confgured it will default to the UK (ISO code GB).
                        p For more details on the territories for which Moonpull is configured please contact your Moonpull lead.
                        p Moonpull provides a badge in the Audit Results Details to confirm the data centre that was used.
                
                MInput( 
                  type="text"
                  name="cookieName"
                  label="Network memory cookie name"
                )

                MInput(
                  type="select" 
                  name="cookieType"
                  v-bind:options="cookieTypeOptions" 
                  label="Cookie Type"
                )

                MInput(
                  type="text"
                  name="customAni"
                  label="ANI parameter name"
                )
                MInput(
                  type="text"
                  name="customNetwork"
                  label="Network tag name/component"
                )

                br
                h2 Tech publisher - additional fields

                MInput(
                  type="text"
                  name="advertiserHome"
                  label="Starting url"
                  required
                )

                MInput(
                  type="text"
                  name="techCookieName"
                  label="Tech publisher's cookie name"
                  required
                )

                MInput(
                  type="text"
                  name="techMasterTag"
                  label="Tech publisher's tag name"
                  required
                )

                h2 Tag metadata - applied to all links in the created

                MInput(
                  type="text"
                  name="tagB"
                  label="Tag B:"
                )

                MInput( 
                  type="text"
                  name="tagC"
                  label="Tag C:"
                )

                MInput( 
                  type="text"
                  name="tagD"
                  label="Tag D:"
                )

                MInput( 
                  type="text"
                  name="tagE"
                  label="Tag E:"
                )

                hr

                MInput(
                  type="checkbox"
                  name="notifyOnComplete"
                  label="Send email notification on completion"
                )
                
                hr

                span( v-if="$moonpull.currentUserIsSuperAdmin()" )
                  MMoonpullIcon
                  | &nbsp; SU Only

                template( v-if="$moonpull.currentUserIsSuperAdmin()" )
                  MInput(
                    type="checkbox"
                    name="proxyYN"
                    label="Residential Proxy:"
                  )

                  MInput( 
                    type="select"
                    name="proxyCountryCode"
                    v-bind:options="countryCodes"
                    label="Proxy Region"
                  )
                  
                  MInput( 
                    type="checkbox" 
                    name="extraTimeout"
                    label="Extra Timeout"
                  )
                  
                MLinkCheckerQueueSelector( v-bind:company="company" v-bind:batch-meta="batchMeta" v-bind:queue-counts="queueCounts" )

          div( v-bind:class="[ 'tab-pane', currentTab === 'multiCountry' && 'active' ]" )
            div( class="panel-body text-left" )
              h2 Multi-Country

              MForm( v-on:submit="multiCountrySubmit")
                MInput(
                  type="text"
                  name="batchName"
                  label="Advertiser Name"
                  required
                )
                MInput(
                  type="text"
                  name="batchDescription"
                  label="Advertiser Description"
                )
                MInput(
                  type="text"
                  name="link"
                  label="Affiliate Link"
                  required
                )
                MInput(
                  type="select"
                  name="userDefinedNetwork"
                  required
                  v-bind:options="networks.map(n => ({ label: n.name, value: n.name }))" 
                  label="Network" 
                  v-on:change="onNetworkChange"
                )
                MInput(
                  type="select"
                  multiple
                  name="countryCode"
                  v-bind:options="countryCodes"
                  value="gb"
                  label="Country Code"
                  description="Control-click / shift-click to select multiple countries"
                )
                hr
                MInput(
                  type="text"
                  name="memoryCookeName"
                  label="Memory Cookie Name"
                )
                MInput(
                  type="select"
                  name="cookieType"
                  v-bind:options="cookieTypeOptions"
                  label="Cookie Type"
                )
                MInput(
                  type="text"
                  name="customAni"
                  label="Custom ANI"
                )
                hr
                MInput(
                  type="text"
                  name="tagA"
                  label="Tag A:"
                )
                MInput(
                  type="text"
                  name="tagB"
                  label="Tag B:"
                )
                MInput( 
                  type="text"
                  name="tagC"
                  label="Tag C:"
                )
                MInput( 
                  type="text"
                  name="tagD"
                  label="Tag D:"
                )
                MInput( 
                  type="text"
                  name="tagE"
                  label="Tag E:"
                )
          
          div(v-bind:class="[ 'tab-pane', currentTab === 'consentAnalysis' && 'active' ]")
            div(class="panel-body text-left")
              h2 Consent Checker
              p This creates a batch of links in a pre-defined format looking at affiliate tracking in relation to four consent scenarios

              MForm(v-on:submit="submitConsentAnalysis" v-bind:submit-text="consentCheckerSubmitText")

                MInput(
                  type="text"
                  required
                  name="batchName"
                  label="Advertiser Name"
                )
                MInput(
                  type="text"
                  name="batchDescription"
                  label="Advertiser Description"
                )
                MInput(
                  type="text"
                  required
                  name="link"
                  label="Affiliate Link"
                )
                MInput(
                  type="text"
                  name="advertiserHome"
                  label="Navigation url"
                  required
                )
                MInput(
                  type="select"
                  name="userDefinedNetwork"
                  required
                  v-bind:options="networks.map(n => ({ label: n.name, value: n.name }))" 
                  label="Network" 
                  v-on:change="onNetworkChange"
                )
                MInput(
                  type="select"
                  required
                  name="countryCode"
                  v-bind:options="countryCodes"
                  value="gb"
                  label="Country Code"
                )
                  MModalButton(slot="description" container-classes="d-inline" button-classes="btn-link font-bold" modal-size="modal-lg" title="Choosing a Queue")
                    span(slot="button-inner")
                      |
                      i(class="fa fa-question inline-block ml-2")
                    p(slot="body" class="text-left font-normal")
                      ul
                        p Moonpull asks you to select a Country Code for link submission.
                        p Moonpull utilises data centres in approximately 50 counties, with the data centre specified within the submission data using the relevant ISO Alpha-2 code.
                        p If you choose a country for which Moonpull is not configured it will default to the UK (ISO)
                hr
                label
                  input( type="checkbox" v-model="linkView")
                  em( class="ml-2") Additional Fields
                div( v-if="linkView" )
                  MInput(
                    type="text"
                    name="memoryCookieName"
                    label="Memory Cookie Name"
                  )
                  MInput(
                    type="select" 
                    name="cookieType"
                    v-bind:options="cookieTypeOptions" 
                    label="Cookie Type"
                  )
                  MInput(
                    type="text"
                    name="customAni"
                    label="Custom ANI"
                  )
                  hr
                  MInput(
                    type="text"
                    name="tagB"
                    label="Tag B:"
                  )
                  MInput(
                    type="text"
                    name="tagC"
                    label="Tag C:"
                  )
                  MInput(
                    type="text"
                    name="tagD"
                    label="Tag D:"
                  )
                  MInput(
                    type="text"
                    name="tagE"
                    label="Tag E:"
                  )
                  div( v-if="$moonpull.currentUserIsSuperAdmin()" )
                    MMoonpullIcon
                    label(class="mx-2") Enhanced Scenario
                    input(
                      type="checkbox"
                      name="isEnhancedScenario"
                      class="checkbox"
                      v-model="isEnhancedScenario"
                      v-on:change="onConsentCheckerScenarioChange"
                      v-if="$moonpull.currentUserIsSuperAdmin()"
                    )

</template>

<style lang="scss" scoped>
td.link-col {
  word-break: break-word;
  max-width: 80%;
}
.toggle-moonpull-admin-options {
  cursor: pointer;
}
</style>

<script>
import Vue from "vue";
import * as dateFormat from "dateformat";
import gql from "graphql-tag";
import { countryCodes } from "@/countryCodes";
import { createTechPublisherScenario } from "@/createTechPublisherScenario";
import { createConsentAnalysisScenario } from "@/createConsentAnalysisScenario";
import { flashMessage } from "@/store";
export default Vue.extend({
  data() {
    return {
      countryCodes,

      breadcrumbs: [
        { label: "Home", link: "/" },
        { label: "Link Checker", link: "/link-checker" },
      ],
      currentTab: "single-with-data",
      loading: true,
      loadingMultipleLinkSubmission: false,

      singleLink: "",
      singleLinkValidationMessage: null,

      multiLinks: "",
      multiLinkValidationMessage: null,
      multiLinkAuditResults: [],

      csv: null,
      fileUploadError: "",

      cookieTypeOptions: [
        {
          value: null,
          label: "None",
        },
        {
          value: "1",
          label: "ANI",
        },
        {
          value: "3",
          label: "Wildcard",
        },
      ],

      gdprOptions: [
        {
          value: "n",
          label: "N",
        },
        {
          value: "y",
          label: "Y",
        },
      ],

      timeoutOptions: [
        {
          value: "Yes",
          label: "Yes",
        },
        {
          value: "No",
          label: "No",
        },
      ],

      networkOptions: [{ value: "awin", label: "Awin" }],

      validBatchName: true,

      batchMeta: {
        queueLetter: null,
        mobile: false,
        proxy: "gb",
        userAgent: true,
        useResidentialProxy: false,
        notifyOnComplete: true,
        standDownMrAs: false,
        setLoyaltyContext: false,
      },

      company: null,
      linkView: false,

      showLinkConnectorReferrerWarning: false,

      techPublisherSubmitText: "Submit Default (6 links)",
      techPublisherScenarios: [
        {
          label: "Default (6 links)",
          value: "simplified",
        },
        {
          label: "Detailed (12 links)",
          value: "default",
        },
      ],
      consentCheckerSubmitText: "Submit Default (2 links)",
      consentCheckerScenarios: [
        {
          label: "Default (2 links)",
          value: "default",
        },
        {
          label: "Enhanced (4 links)",
          value: "enhanced",
        },
      ],
      isEnhancedScenario: false,

      showAdditionalOptions: false,
    };
  },

  apollo: {
    queueCounts: {
      query: gql`
        query {
          queueCounts {
            name
            count
          }
        }
      `,
      variables() {
        return {
          companyId: this.$moonpull.getCurrentUserSession().company.id,
        };
      },
    },
  },

  watch: {
    ["batchMeta.name"]() {
      this.validBatchName = !!this.batchMeta.name;
    },
  },

  computed: {
    percentageLinksRemaining() {
      return (
        (this.company.remainingAudits /
          (this.company.numMonthlyLinks + this.company.numExtraMonthlyLinks)) *
        100
      );
    },

    linksRemainingProgressBarClass() {
      if (100 - this.percentageLinksRemaining < 75) {
        return "primary";
      } else if (100 - this.percentageLinksRemaining < 90) {
        return "warning";
      }
      return "danger";
    },
  },

  methods: {
    dateFormat,

    toggleAdditionalOptions() {
      this.showAdditionalOptions = !this.showAdditionalOptions;
    },

    changeTab(tab) {
      this.currentTab = tab;
      if (this.company && this.company.queues) {
        if (this.currentTab === "single-with-data") {
          this.batchMeta.queueLetter = "a";
        } else if (this.currentTab === "upload") {
          if (this.company.queues.find((queueLetter) => queueLetter === "c")) {
            this.batchMeta.queueLetter = "c";
          } else {
            this.batchMeta.queueLetter = this.company.queues[0];
          }
        }
      }
    },

    updateCsvFile(e) {
      const file = e.target.files[0];

      if (!file.name.endsWith(".csv")) {
        this.fileUploadError = "Only .CSV files are supported";
        return;
      }

      this.fileUploadError = "";
      this.csv = file;
    },

    async uploadCsv() {
      if (!this.isBatchNameValid()) return;
      if (!this.noDescriptionConfirmation()) return;

      this.loading = true;

      analytics.track("Csv Uploaded", {});

      this.$moonpull
        .auditFromCsv(this.csv, this.batchMeta)
        .then((newBatch) => {
          if (newBatch) {
            this.$router.push({
              name: "reporting-batches",
              query: { newBatch: newBatch.batchId },
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    validateLink(link) {
      // TODO: More rigid validation checks for links
      return link.startsWith("http");
    },

    isSingleLinkValid() {
      return this.validateLink(this.singleLink);
    },

    noDescriptionConfirmation() {
      if (!this.batchMeta.description) {
        return confirm(
          "You have left the description field empty.  This will make it harder to find the data in the future.  Are you sure?"
        );
      }
      return true;
    },

    areMultiLinksValid() {
      const allMultiLinks = this.multiLinks.split("\n");
      for (let i = 0; i < allMultiLinks.length; i++) {
        if (!this.validateLink(allMultiLinks[i])) {
          return false;
        }
      }
      return true;
    },

    isBatchNameValid() {
      this.validBatchName = !!this.batchMeta.name;
      return this.validBatchName;
    },

    audit() {
      if (!this.isBatchNameValid()) return;
      if (!this.noDescriptionConfirmation()) return;

      if (this.isSingleLinkValid() && this.isBatchNameValid()) {
        this.loading = true;
        this.$moonpull
          .audit(
            [
              {
                link: this.singleLink,
                countryCode: this.batchMeta.proxy,
                proxyYN: this.batchMeta.useResidentialProxy,
              },
            ],
            this.batchMeta
          )
          .then((newBatch) => {
            if (newBatch) {
              this.$router.push({
                name: "reporting-batch",
                params: { batchId: newBatch.batchId },
              });
            }
            this.loading = false;
          });
      }
    },

    multiAudit() {
      if (!this.isBatchNameValid()) return;
      if (!this.noDescriptionConfirmation()) return;

      this.loading = true;
      const allMultiLinks = this.multiLinks.split("\n").map((link) => ({
        link,
        countryCode: this.batchMeta.countryCode,
        proxyYN: this.batchMeta.useResidentialProxy,
      }));
      this.$moonpull.audit(allMultiLinks, this.batchMeta).then((newBatch) => {
        if (newBatch) {
          this.$router.push({
            name: "reporting-batches",
            query: { newBatch: newBatch.batchId },
          });
        }
        this.loading = false;
      });
    },

    async downloadCsv() {
      this.downloadingCsv = true;
      this.$moonpull.downloadFile(
        "text/csv",
        "default.csv",
        "Affiliate Link,Network,Advertiser,Country Code,Tag A,Tag B,Tag C,Tag D,Tag E"
      );
      this.downloadingCsv = false;
    },

    submitLink(data) {
      analytics.track("Single Link Uploaded", {});

      // Cookie name/type must both be specified or neither
      if (
        (data.cookieName && !data.cookieType) ||
        (!data.cookieName && data.cookieType)
      ) {
        this.$store.dispatch("flashMessage", {
          type: "warning",
          msg: `Cookie Name and Cookie Type must both be specified, if at all.`,
        });
        return;
      }
      // Check for valid URL
      try {
        new URL(data.link);
      } catch (e) {
        this.$store.dispatch("flashMessage", {
          type: "danger",
          msg: `Invalid affiliate link. Please make sure the link is a valid URL.`,
        });
        return;
      }

      // Post the audit
      this.loading = true;
      this.$moonpull
        .audit(
          [
            {
              ...data,
              advertiser: data.batchName,
            },
          ],
          {
            ...this.batchMeta,
            name: data.batchName,
            description: data.batchDescription,
            useLite: data.useLite,
          }
        )
        .then((newBatch) => {
          if (newBatch) {
            this.$router.push({
              name: "reporting-batches",
              query: { newBatch: newBatch.batchId },
            });
          }
          this.loading = false;
        });
      this.$emit("dismissModals");
    },

    createLink() {},

    onNetworkChange(e) {
      this.showLinkConnectorReferrerWarning = [
        "LinkConnector",
        "LC Naked",
      ].includes(e.target.value);
    },

    isUrlValid(url) {
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },

    async submitTechLink(data) {
      if (!this.isUrlValid(data.advertiserHome)) {
        this.$store.dispatch("flashMessage", {
          type: "danger",
          msg: `Invalid "Starting URL". Please make sure it is a full URL including http(s)://`,
        });
        return;
      }

      this.loading = true;

      const audits = createTechPublisherScenario(
        data.techPublisherScenario,
        data
      );

      // Submit the custom batch
      const newBatch = await this.$moonpull.audit(audits, {
        // Batch Meta
        name: data.batchName,
        description: data.batchDescription,
        queueLetter: this.batchMeta.queueLetter,
        notifyOnComplete: data.notifyOnComplete,
        useLite: false,
        autoCreateAdvertisers: false,
      });

      if (newBatch) {
        this.$router.push({
          name: "reporting-batches",
          query: { newBatch: newBatch.batchId },
        });
      }
      this.loading = false;
    },

    onTechPublisherScenarioChange(e) {
      const { value } = e.target;
      if (value === "default") {
        this.techPublisherSubmitText = "Submit Default (12 links)";
      } else if (value === "simplified") {
        this.techPublisherSubmitText = "Submit Simplified (6 links)";
      } else {
        throw new Error(
          `Unexpected select value for tech publsiher scenario: ${value}`
        );
      }
    },

    onConsentCheckerScenarioChange() {
      if (this.isEnhancedScenario) {
        this.consentCheckerSubmitText = "Submit Enhanced (4 links)";
      } else {
        this.consentCheckerSubmitText = "Submit Default (2 links)";
      }
    },

    async multiCountrySubmit(data) {
      this.loading = true;
      const allMultiLinks = data.countryCode.map((countryCode) => ({
        link: data.link,
        countryCode,
        userDefinedNetwork: data.userDefinedNetwork,
        tagA: data.tagA,
        tagB: data.tagB,
        tagC: data.tagC,
        tagD: data.tagD,
        tagE: data.tagE,
        cookieName: data.cookieName,
        cookieType: data.cookieType,
        customAni: data.customAni,
      }));
      const newBatch = await this.$moonpull.audit(allMultiLinks, {
        name: data.batchName,
        description: data.batchDescription,
        queueLetter: this.batchMeta.queueLetter,
        notifyOnComplete: data.notifyOnComplete,
      });
      if (newBatch) {
        this.$router.push({
          name: "reporting-batches",
          query: { newBatch: newBatch.batchId },
        });
      }
      this.loading = false;
    },

    // Method to toggle scenario text based on checkbox
    onConsentCheckerScenarioChange() {
      this.consentCheckerSubmitText = this.isEnhancedScenario
        ? "Submit Enhanced (4 links)"
        : "Submit Default (2 links)";
    },

    async submitConsentAnalysis(data) {
      if (!this.isUrlValid(data.advertiserHome)) {
        this.$store.dispatch("flashMessage", {
          type: "danger",
          msg: `Invalid "Starting URL". Please make sure it is a full URL including http(s)://`,
        });
        return;
      }

      this.loading = true;

      // Determine scenario type based on `isEnhancedScenario`
      const scenarioType = this.isEnhancedScenario ? "enhanced" : "default";

      // Call `createConsentAnalysisScenario` and log the output
      const audits = createConsentAnalysisScenario(scenarioType, data);

      // Continue with submission
      const newBatch = await this.$moonpull.audit(audits, {
        name: data.batchName,
        description: data.batchDescription,
        queueLetter: this.batchMeta.queueLetter,
        notifyOnComplete: data.notifyOnComplete,
        useLite: false,
        autoCreateAdvertisers: false,
      });

      if (newBatch) {
        this.$router.push({
          name: "reporting-batches",
          query: { newBatch: newBatch.batchId },
        });
      }

      this.loading = false;
    },
  },

  async beforeMount() {
    // Load networks
    this.networks = await this.$moonpull.getNetworks(this.$apollo);

    const companyQueryRes = await this.$apollo.query({
      query: gql`
        query CompanyById($id: ID!) {
          companyById(id: $id) {
            id
            name
            resetDay
            nextResetDate
            numMonthlyLinks
            numExtraMonthlyLinks
            maxBatchSize
            numAudits
            remainingAudits
            queues
          }
        }
      `,
      variables: {
        id: this.$moonpull.getCurrentUserSession().company.id,
      },
    });
    this.company = companyQueryRes.data.companyById;
    if (this.company && this.company.queues && this.company.queues[0]) {
      this.batchMeta.queueLetter = this.company.queues[0];
    }
    this.loading = false;
  },

  beforeCreate() {
    analytics.page(" view", {
      path: window.location.hash,
      referrer: window.location.hash,
    });
  },
});
</script>
